import { defineMessages } from 'react-intl';

export default defineMessages({
  title: { defaultMessage: 'Borrow Composition' },
});
